import { Component, Input } from '@angular/core';
import { ClubOverviewService } from '~features/club-overview/club-overview.service';
import { Club } from '~core/models';
import { TooltipTranslationService } from '~shared/translations';

/**
 * Component that lets you interact with the webpage individualization settings
 */
@Component({
  selector: 'app-club-gdpr-settings-info',
  templateUrl: './club-gdpr-settings-info.component.html',
  styleUrls: ['../../../pages/club-settings/club.component.scss']
})
export class ClubGdprSettingsInfoComponent {
  @Input() public selectedClub: Club;

  constructor(
    public clubOverviewService: ClubOverviewService,
    public tooltipTranslations: TooltipTranslationService,
  ) { }

  public editGdprSettings(): void {
    this.clubOverviewService.toggleEditClubGdprSettingsModal(true);
  }
}
